import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

export default function RatingModal({show, onHide, minRating, setMinRating, maxRating, setMaxRating}) {

    const minInputRef = useRef(null)
    const maxInputRef = useRef(null)

    const [min, setMin] = useState(minRating)
    const [max, setMax] = useState(maxRating)

    const handleClick = () => {

        if(min > max) {
            toast.error('Min Rating Cannot be greater than Max Rating');
            return;
        }
        
        setMinRating(min);
        setMaxRating(max);

        onHide()
    }

    return (
        <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header >
          <Modal.Title>
            <h4 className="text-primary">Problem Rating Filter</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-between flex-column">

                <label htmlFor="minRating">Min Rating</label>
                <input 
                    type="number" 
                    className="form-control" 
                    id="minRating" 
                    ref={minInputRef} 
                    value={min} 
                    onChange={(e) => setMin(e.target.value)}
                />

                <label htmlFor="Max Rating">Max Rating</label>
                <input 
                    type="number" 
                    className="form-control" 
                    id="maxRating" 
                    ref={maxInputRef} 
                    value={max} 
                    onChange={(e) => setMax(e.target.value)}
                />

          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="custom-button text-dark" onClick={onHide}>
            Close
          </button>
          <button className="custom-button text-success" onClick={handleClick}>Filter</button>
        </Modal.Footer>
      </Modal>
    );
  }